import { currentAccountProviderTypeSelector } from "./currentAccountProviderTypeSelector";
import { RootState } from "../../../store";
import { resourceTypeDataSpendingSelector } from "../resource-type-data/resourceTypeDataSpendingSelector";
import { ResourceType } from "../../../../services/cloudchipr.api";
import { resourceTypesByProvider } from "../../../../utils/helpers/providers/resourceTypesByProvider";

export const currentAccountSpendingSelector = (
  state: RootState,
  resourceTypesToSkip?: Map<ResourceType, boolean>,
) => {
  const provider = currentAccountProviderTypeSelector(state);
  if (!provider) {
    return;
  }

  const resourceTypes = resourceTypesByProvider(provider).filter(
    (resourceType) => !resourceTypesToSkip?.get(resourceType),
  );

  return (
    resourceTypes
      ?.map((resourceType) =>
        resourceTypeDataSpendingSelector(state, resourceType),
      )
      ?.reduce((acc, currentValue) => acc + currentValue, 0) || 0
  );
};
